import React, { useEffect } from 'react'
import HeadSalesWrapper from '../HeadSalesWrapper'
import HeadSalesNavItem from './HeadSalesNavItem'
import { NotificationsNoneOutlined, ReportProblemOutlined, BusinessCenterOutlined, ShoppingCartOutlined, PublicOutlined, RequestQuoteOutlined, InfoOutlined, ListAltOutlined, TrendingUpOutlined, BarChartOutlined, EmojiEventsOutlined, TrackChangesOutlined, SummarizeOutlined } from '@mui/icons-material'
//import {LocalShippingOutlined, ReceiptLongOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import ComplaintNavItem from '../../Client/NavItems/ComplaintNavItem'
import { connect, useDispatch } from 'react-redux'
import { fetchUnreadComplaintsCount } from '../../../actions/complaint/complaintList'
import { Collapse } from '@mui/material'
import { SessionState } from '../../../reducers/auth/session'
import { AppState } from '../../../reducers'


// Props que vienen del store
interface StateProps {
  session?: SessionState
}

interface OwnProps {
  open?: boolean
  // otras props que uses desde NavMenu
}

type Props = StateProps & OwnProps;

const HeadSalesNavItems: React.FC<Props> = ({ session, ...props }) => {
  const { t } = useTranslation("menu")
  const dispatch = useDispatch()
  const [openDownload, setOpenDownload] = React.useState(false);
  const [openGoal, setOpenGoal] = React.useState(false);


  const handleDownloadClick = () => {
    setOpenDownload(!openDownload);
  };

  const getComplaintCount = () => {
    dispatch(fetchUnreadComplaintsCount())
  }


  const handleGoalClick = () => {
    setOpenGoal(!openGoal);
  };

  useEffect(() => {
    getComplaintCount()
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [])


  return <HeadSalesWrapper>
    <HeadSalesNavItem
      uri='clients'
      title={t('clients')}
      icon='people'
      {...props}
    />

    <HeadSalesNavItem
      uri='people'
      title={t('people')}
      icon='contacts'
      {...props}
    />

    <HeadSalesNavItem
      uri='vendors'
      title={t('vendors')}
      icon={<BusinessCenterOutlined />}
      {...props}
    />


    <HeadSalesNavItem
      uri='preorders'
      title={t('preorders')}
      icon={<ShoppingCartOutlined />}
      {...props}
    />

    <ComplaintNavItem
      base='headsales'
      uri='complaints'
      title={t('complaintsList')}
      icon={<ReportProblemOutlined />}
      {...props}
    />


    <HeadSalesNavItem
      uri='goals'
      title={t('goals')}
      icon={<TrackChangesOutlined />}
      nested
      onClick={handleGoalClick}
      openItem={openGoal}
      {...props}
    />

    <Collapse in={openGoal} timeout="auto" style={{
      marginTop: openGoal ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: openGoal ? props.open ? "-16px" : "-6px" : "-16px"
    }}>
      {!session?.isChaco && <HeadSalesNavItem
        uri='goals'
        title={t('adminGoals')}
        icon={<EmojiEventsOutlined />}
        subItem
        {...props}
      />}

      <HeadSalesNavItem
        uri='goals-stats-client'
        title={t('clientGoals')}
        icon={<BarChartOutlined />}
        subItem
        {...props}
      />
      <HeadSalesNavItem
        uri='goals-stats-vendor'
        title={t('vendorGoals')}
        icon={<TrendingUpOutlined />}
        subItem
        {...props}
      />
      {/*
      <HeadSalesNavItem
        uri='vendorClientBrandMatrix'
        title={t('brandGoals')}
        icon={<CopyrightOutlined />}
        subItem
        {...props}
      />*/}
    </Collapse>

    <HeadSalesNavItem
      uri='notifications'
      title={t('notifications')}
      icon={<NotificationsNoneOutlined />}
      {...props}
    />

    <HeadSalesNavItem
      uri='logs'
      title={t('logs')}
      icon={<ListAltOutlined />}
      {...props}
    />

    {!session?.isChaco && <HeadSalesNavItem
      uri='countries'
      title={t('countries')}
      icon={<PublicOutlined />}
      {...props}
    />}

    <HeadSalesNavItem
      uri='downloads'
      title={t('downloadReport')}
      nested
      icon={<InfoOutlined />}
      onClick={handleDownloadClick}
      openItem={openDownload}
      {...props}
    />

    <Collapse in={openDownload} timeout="auto" style={{
      marginTop: openDownload ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: openDownload ? props.open ? "-16px" : "-6px" : "-16px"
    }}>
      <HeadSalesNavItem
        uri='dlPriceList'
        title={t('priceList')}
        icon={<RequestQuoteOutlined />}
        subItem
        {...props}
      />
      <HeadSalesNavItem
        uri='currentAccountSummary'
        title={t('currentAccountSummary')}
        icon={<SummarizeOutlined />}
        subItem
        {...props}
      />

    </Collapse>


    {/*<HeadSalesNavItem
      uri='payments'
      title={t('paymentsList')}
      icon={<ReceiptLongOutlined />}
      {...props}
/>*/}
  </HeadSalesWrapper>
}


const mapStateToProps = (state: AppState): StateProps => ({
  session: state.session
})

// Ahora TypeScript sabe que open es prop propia (OwnProps)
export default connect<StateProps, {}, OwnProps, AppState>(mapStateToProps)(HeadSalesNavItems);

